// extracted by mini-css-extract-plugin
export default {"link":"style_link__LC8G6","centerGrid":"style_centerGrid__cz24K","img":"style_img__vKi5W","namegame":"style_namegame__JxsqN"};